import { z } from "zod";
import {
  mobileOrchestrator,
  multiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";

export const orchestrator = z.union([
  mobileOrchestrator,
  multiOrderOrchestrator,
]);
